module.exports = __webpack_public_path__ + "img/img15.f010fe8b.svg";